module.exports = __webpack_public_path__ + "img/img1.eb8a12da.jpg";